<div
  cdkDrag
  cdkDragRootElement=".resizable-mat-dialog-panel"
  cdkDragBoundary=".main-app"
>
  <div class="company-announcement-dialog-header">
    <div
      cdkDragHandle
      [innerHTML]="data.filingsHeading"
      class="company-announcement-dialog-title"
    ></div>
    <div (click)="closeDialog()">
      <va-icon
        name="close-circle"
        class="company-announcement-dialog-close-icon"
      ></va-icon>
    </div>
  </div>
  <div class="company-announcement-dialog-content">
    <div class="company-announcement-dialog-header-action">
      <div class="doc-details">
        <div class="doc-type">
          <div class="detail-title">Document Type:</div>
          <div class="detail-value">{{ data.documentType }}</div>
        </div>
        <div class="date-pub">
          <div class="detail-title">Date Published:</div>
          <div class="detail-value">{{ data.datePublish }}</div>
        </div>
      </div>
      <a class="modal-header-link" (click)="handleOpenInWindow($event)">
        Open in New Tab
      </a>
      <div class="guidance-navigation" *ngIf="data.hasGuidance">
        <div class="guidance-title">
          <va-icon
            [name]="'guidance'"
            size="medium"
            class="data-setting-icon guidance-icon"
          ></va-icon>
          Guidance
        </div>
        <div class="guidance-navigator">
          <va-icon
            [name]="'chevron-left'"
            class="data-setting-icon navigator-element"
            size="small"
            (click)="onPrevGuidance()"
          ></va-icon>
          <div class="guidance-index">
            {{ data.currentGuidance }}
          </div>
          <div class="navigator-element">/</div>
          <div class="guidance-count navigator-element">
            {{ data.guidanceCount }}
          </div>
          <va-icon
            [name]="'chevron-right'"
            class="data-setting-icon navigator-element"
            size="small"
            (click)="onNextGuidance()"
          ></va-icon>
        </div>
      </div>
    </div>
    <div class="modal-content">
      <!-- <div
        class="modal-sidebar"
        [ngClass]="{ 'modal-sidebar--collapsed': !isLeftSidebarActive }"
      >
        <div
          class="modal-sidebar-handle modal-sidebar-handle-left"
          (click)="handleleftsidebarClick()"
        >
          <va-icon
            *ngIf="!isLeftSidebarActive"
            size="small"
            name="arrow-circle-right"
            class="sider-icon"
          ></va-icon>
          <va-icon
            *ngIf="isLeftSidebarActive"
            size="small"
            name="arrow-circle-left"
            class="sider-icon"
          ></va-icon>
        </div>
        <div class="sidebar-content">left sidebar</div>
      </div> -->
      <div
        style="height: 400px"
        *ngIf="data.gettingPDFURL && !data.filingsError"
      ></div>
      <div class="iframe-container" *ngIf="!data.filingsError">
        <iframe
          [src]="data.viewModalSrc"
          id="filingsFrame"
          frameborder="0"
          allowfullscreen
          *ngIf="
            data.filingFileType === 'pdf' &&
            !data.filingsError &&
            !data.gettingPDFURL
          "
        ></iframe>
        <iframe
          id="filingsFrame"
          frameborder="0"
          allowfullscreen
          *ngIf="
            (data.filingFileType === 'htm' || data.filingFileType === 'html') &&
            !data.filingsError
          "
        ></iframe>
      </div>
      <div id="filings-error" class="error-container" *ngIf="data.filingsError">
        <div class="error-msg">
          <va-icon name="info-circle" class="info-icon"></va-icon>
          <span class="error-text">Filings not found</span>
        </div>
      </div>
      <!-- <div
        class="modal-sidebar"
        [ngClass]="{ 'modal-sidebar--collapsed': !isRightSidebarActive }"
      >
        <div
          class="modal-sidebar-handle modal-sidebar-handle-right"
          (click)="handleRightSidebarClick()"
        >
          <va-icon
            *ngIf="!isRightSidebarActive"
            size="small"
            name="arrow-circle-left"
            class="sider-icon"
          ></va-icon>
          <va-icon
            *ngIf="isRightSidebarActive"
            size="small"
            name="arrow-circle-right"
            class="sider-icon"
          ></va-icon>
        </div>
        <div class="sidebar-content">Right sidebar</div>
      </div> -->
    </div>
  </div>
</div>
